import { COLOR } from "@finway-group/shared/lib/consts/colors"
import { getApprovalProcessScopeFromPurchaseOrderStatus } from "@finway-group/shared/lib/utils/approvalProcess.utils"
import { Button, PageHeader, Row, Space, Tooltip } from "antd"
import React from "react"
import { ArrowLeftCircle, ArrowRightCircle, Edit2 as EditIcon, MoreHorizontal as MoreIcon } from "react-feather"
import { useTranslation } from "react-i18next"
import { ApprovalProcessIndicatorMenu } from "~Components/approvalProcessesIndicator"
import { isPurchaseOrderInEditableState } from "~Features/pages/purchaseOrders/types/utils/helper.util"
import { AuthzService } from "~Shared/services"
import { getTooltipPopupContainer } from "~Shared/utils/helper.utils"
import { PurchaseOrder } from "../types/PurchaseOrder.interfaces"
import { PurchaseOrderOptionButtons } from "./PurchaseOrderOptionButtons"
import { PurchaseOrderTags } from "./PurchaseOrderTags"

interface PurchaseOrderDetailsHeaderProps {
    title: React.ReactNode
    purchaseOrder: PurchaseOrder
    tags: Array<string>
    onBack: () => void
    onAddTag?: (id: string, detach: boolean) => void
    onEdit?: () => void
    onDelete?: () => void
    onPrev?: () => void
    onNext?: () => void
}

export const PurchaseOrderDetailsHeader = ({ title, purchaseOrder, onBack, onAddTag, onEdit, onPrev, onNext, tags, onDelete }: PurchaseOrderDetailsHeaderProps) => {
    const { t } = useTranslation()

    const scope = getApprovalProcessScopeFromPurchaseOrderStatus(purchaseOrder.state.currentState)

    const buttons = (
        <Space>
            <PurchaseOrderTags purchaseOrderTags={tags} onTagChange={onAddTag} />

            <Row className="flex-no-wrap gap-8">
                <ApprovalProcessIndicatorMenu approvalProcesses={purchaseOrder.approvalProcesses!} scope={scope} />
                {AuthzService.isLoggedInUserAllowedToUpdatePurchaseOrder(purchaseOrder) && !purchaseOrder.deleted ? (
                    <Tooltip
                        getPopupContainer={getTooltipPopupContainer}
                        placement="bottomLeft"
                        title={!isPurchaseOrderInEditableState(purchaseOrder) ? t("tooltips:purchase_order.not_editable.approved") : ""}
                    >
                        <Button className="m-5 btn-default" disabled={!isPurchaseOrderInEditableState(purchaseOrder)} onClick={onEdit}>
                            <EditIcon />
                            <span>{t("action:edit")}</span>
                        </Button>
                    </Tooltip>
                ) : null}
            </Row>

            <PurchaseOrderOptionButtons record={purchaseOrder} onDelete={onDelete}>
                <Button onClick={(e) => e.stopPropagation()} className="m-5 btn-default">
                    <MoreIcon />
                </Button>
            </PurchaseOrderOptionButtons>
            <Button onClick={onPrev} disabled={!onPrev} className="m-5 btn-default">
                <ArrowLeftCircle color={!onPrev ? COLOR.button.disabled : undefined} />
            </Button>
            <Button onClick={onNext} disabled={!onNext} className="m-5 btn-default">
                <ArrowRightCircle color={!onNext ? COLOR.button.disabled : undefined} />
            </Button>
        </Space>
    )

    return <PageHeader title={title} extra={buttons} onBack={onBack} />
}
